import { ResourceFavoriteMutationActionType } from './custom/resource-favorites-mutations/types';
import { LessonPlanEntityMutationActionType } from './custom/lesson-plan-mutations/types';

export enum EntityActionType {
  REQUEST_IN_FLIGHT = 'REQUEST_IN_FLIGHT',
  REQUEST_SUCCESS = 'REQUEST_SUCCESS',
  REQUEST_ERROR = 'REQUEST_ERROR',
  CANCEL_DOWNLOAD_REQUEST = 'CANCEL_DOWNLOAD_REQUEST',
  WORKBOOK = 'WORKBOOK',
  RESET_KEY = 'RESET_KEY',
  CANCEL_LOADING = 'CANCEL_LOADING'
}

export type EntityState = {
  loading: boolean;
  requestCounter: number;
  errors: string[];
  licenses: any[];
  licensesById: { [key: string]: any };
  lastTeachersGuide: any;
  lastWorkbook: any;
  workbooks: any[];
  workbooksById: { [key: string]: any };
  featureToggles: { [key: string]: any };
  featureTogglesById: { [key: string]: any };
  featureTogglesByName: { [key: string]: any };
  filterGroups: any[];
  filterGroupsByFilter: any[];
  resources: any[];
  resoucesById: { [key: string]: any };
  favoriteResources: any[];
  favoriteResourcesById: { [key: string]: any };
  characters: any[];
  characterswdt: any[];
  characterslnf: any[];
  characterswoodPieces: any[];
  charactersById: { [key: string]: any };
  clickAways: Array<any>;
  copyrightTerms: any;
  pdf: null;
  pageDetails: { [key: string]: any };
  workbookContent: null;
  activePdfPageDetails: null;
  teachingOrder: any[];
  lessonPlan: { id: number; name: string; custom: boolean; lessons: any[] };
  updatedProductConfig: any;
  updatedTeachingOrder: any;
  customTeachingOrderCreated: any;
  readlessonPlan: any;
  assignments: any[];
  assignmentsById: { [key: string]: any };
  assignmentDetail: any;
  assignmentAttempt: any;
  assignmentAttemptMessages: any[];
  classrooms: Array<{ id: number; name: string; students: any[]; users: any[] }>;
  classroomsById: { [key: string]: any };
  students: any[];
  studentsById: { [key: string]: any };
  settings: {
    status: number;
    data: { locale: 'en-US' | 'es-US' };
  };
  userAssignments: Array<{
    dayOfWeek: string;
    date: string;
    assignments?: Array<Assignment>;
  }> | null;
  productConfig: {
    active: { id: number; custom: boolean };
    skipDates?: string[];
    emptyDates?: string[];
    startDate: string;
  };
  supportResources: any[] | null;
};

export type Assignment = {
  id: number;
  teachingOrderLessonId: number;
  title: string;
  instructions: string;
  maxAttempts: number;
  dateAssigned: string;
  dateDue: string;
  classroomId: number;
  studentIds?: number[];
  files: any[];
  sections: Array<LessonPlanSection>;
  date?: string;
};

export type EntityOptions = {
  type?: string;
  setValue?: (state: EntityState, data: any) => any;
  keyByProperty?: string | null;
  requestActionType?: string;
};

export type EntityAction =
  | ({ type: EntityActionType.REQUEST_IN_FLIGHT } & EntityOptions)
  | ({ type: EntityActionType.REQUEST_SUCCESS; data: any } & EntityOptions)
  | ({ type: EntityActionType.REQUEST_ERROR; data: string[] } & EntityOptions)
  | ({ type: EntityActionType.CANCEL_DOWNLOAD_REQUEST } & EntityOptions)
  | ({
      type: ResourceFavoriteMutationActionType.CREATE_FAVORITE_SUCCESS;
      data: any;
    } & EntityOptions)
  | ({
      type: ResourceFavoriteMutationActionType.REMOVE_FAVORITE_SUCCESS;
      data: any;
    } & EntityOptions)
  | ({ type: LessonPlanEntityMutationActionType.UPDATE_ENTITY; data: any } & EntityOptions)
  | ({ type: EntityActionType.RESET_KEY; key: string } & EntityOptions)
  | any;

export type LessonPlan = {
  id: number;
  lessonId: number;
  pageId: number;
  title: string;
  page: { id: number; bookId: number; pageNumber: number };
  sections: any[];
  assigned?: boolean;
};

export type LessonsPlanLesson = {
  lessonDate: string;
  dayOfWeek: string;
  lessons: Array<LessonPlan>;
  assignments?: Array<Assignment>;
  date?: string;
  allowInstruction?: boolean;
};

export type LessonPlanSection = {
  id: number;
  lessonId: number;
  title: string;
  activities?: {
    id: number;
    title: string;
    assigned?: boolean;
  }[];
};

export type AssignmentAttempt = {
  id: number;
  teachingOrderLessonId: number;
  title: string;
  maxAttempts: number;
  dateAssigned: Date;
  dateDue: Date;
  classroomId: number;
  studentIds: number[];
  attempts: Array<Attempt>;
};

export type Attempt = {
  studentId: number;
  status: string;
  files: any[];
};
